module.exports = __webpack_public_path__ + "static/media/nodata.5984fa9d.png";